<mat-toolbar>
  <span>কচিকাঁচার বর্ণমালা</span>
  <div class="toolbar-spacer"></div>
</mat-toolbar>
